import React from 'react'

import Base from '../_Base'

const Diamond = (props) => (
  <Base width="14" height="14" viewBox="0 0 14 14" {...props}>
    <path d="M7 4L10 7L7 10L4 7L7 4Z" />
  </Base>
)

export default Diamond
